import { Show } from "solid-js";
import { CheckIcon } from "./check_icon";
import { useDenominationGridContext } from "../context/denomination_grid_context";

export function SingleSubscriptionInfo() {
  const { externalProps, internalState } = useDenominationGridContext();
  const { offerConstruct } = externalProps;
  const { dueAmount, redemptionAmount, discountDetails } = internalState;
  return (
    <div class="flex justify-between">
      <div class="flex flex-col gap-0.5">
        <p class="!text-[13px] text-f12 text-white">Get for</p>
        <div class="flex items-baseline gap-1">
          <p class="text-h3 text-white">₹{dueAmount()}</p>
          <p class="text-medium text-textNormal line-through">
            ₹{redemptionAmount()}
          </p>
        </div>
      </div>
      <div class="flex flex-col justify-end gap-0.5">
        <p class="text-end text-f12 text-textNormal">
          Total savings ₹
          {(offerConstruct?.subscriptionRewardDetails[0].rewardDetails
            .maxAmount ?? 0) *
            (offerConstruct?.subscriptionRewardDetails[0].tenure ?? 0)}
        </p>
        <p class="text-bold text-[#24DD7D]">
          Save ₹{discountDetails?.()?.totalDiscount.amount} / month
        </p>
      </div>
    </div>
  );
}

export function MultipleSubscriptionInfo() {
  const { externalProps, internalState } = useDenominationGridContext();
  const { offerConstruct } = externalProps;
  const {
    dueAmount,
    redemptionAmount,
    discountDetails,
    offerConstructTenure,
    setOfferConstructTenure,
    dueAmount2,
    redemptionAmount2,
    discountDetails2,
  } = internalState;
  return (
    <div class="flex gap-3">
      <div
        class="relative h-[154px] w-full min-w-[149.5px] cursor-pointer rounded-xl p-4  pt-9 darkTheme:bg-[#212427] md:w-[169px]"
        classList={{
          "border border-white":
            offerConstruct?.subscriptionRewardDetails[1]?.tenure ===
            offerConstructTenure?.(),
          "border border-[#212427]":
            offerConstruct?.subscriptionRewardDetails[1]?.tenure !==
            offerConstructTenure?.(),
        }}
        onClick={() => {
          setOfferConstructTenure?.(
            offerConstruct?.subscriptionRewardDetails[1]?.tenure ?? null
          );
        }}
      >
        <Show
          when={
            offerConstruct?.subscriptionRewardDetails[1]?.tenure ===
            offerConstructTenure?.()
          }
        >
          <div class="absolute right-0 top-0 h-6 w-6 stroke-white">
            <CheckIcon size="24" />
          </div>
        </Show>
        <div class="absolute left-0 top-0 flex h-[24px] w-[82px] items-center justify-center rounded-br-xl rounded-tl-xl bg-[#1A4E33] text-smallBold text-[#24DD7D]">
          {offerConstruct?.subscriptionRewardDetails[1].tenure} months
        </div>
        <p class="!text-[13px] text-f12 text-white">Get for</p>
        <div class="flex items-baseline gap-1">
          <p class="text-h3 text-white">₹{dueAmount()}</p>
          <p class="text-medium text-textNormal line-through">
            ₹{redemptionAmount()}
          </p>
        </div>
        <div class="my-2 h-0.5 w-3 rounded-xl bg-[#555]"></div>
        <p class="text-mediumBold text-[#24DD7D]">
          Save ₹{discountDetails?.()?.totalDiscount.amount} / month
        </p>
        <p class="text-f12 text-textNormal">
          Total savings ₹
          {(discountDetails?.()?.totalDiscount.amount ?? 0) *
            (offerConstruct?.subscriptionRewardDetails[1]?.tenure ?? 0)}
        </p>
      </div>
      <div
        class="relative h-[154px] w-full min-w-[149.5px] cursor-pointer rounded-xl p-4 pt-9 darkTheme:bg-[#212427] md:w-[169px]"
        classList={{
          "border border-white":
            offerConstruct?.subscriptionRewardDetails[0]?.tenure ===
            offerConstructTenure?.(),
          "border border-[#212427]":
            offerConstruct?.subscriptionRewardDetails[0]?.tenure !==
            offerConstructTenure?.(),
        }}
        onClick={() => {
          setOfferConstructTenure?.(
            offerConstruct?.subscriptionRewardDetails[0]?.tenure ?? null
          );
        }}
      >
        <Show
          when={
            offerConstruct?.subscriptionRewardDetails[0]?.tenure ===
            offerConstructTenure?.()
          }
        >
          <div class="absolute right-0 top-0 h-6 w-6 stroke-white">
            <CheckIcon size="24" />
          </div>
        </Show>
        <div class="absolute left-0 top-0 flex h-[24px] w-[82px] items-center justify-center rounded-br-xl rounded-tl-xl bg-[#174D5C] text-smallBold text-[#4AC4E5]">
          {offerConstruct?.subscriptionRewardDetails[0].tenure} months
        </div>
        <p class="!text-[13px] text-f12 text-white">Get for</p>
        <div class="flex items-baseline gap-1">
          <p class="text-h3 text-white">₹{dueAmount2?.() ?? ""}</p>
          <p class="text-medium text-textNormal line-through">
            ₹{redemptionAmount2?.()}
          </p>
        </div>
        <div class="my-2 h-0.5 w-3 rounded-xl bg-[#555]"></div>
        <p class="text-mediumBold text-[#24DD7D]">
          Save ₹{discountDetails2?.()?.totalDiscount.amount} / month
        </p>
        <p class="text-f12 text-textNormal">
          Total savings ₹
          {(discountDetails2?.()?.totalDiscount.amount ?? 0) *
            (offerConstruct?.subscriptionRewardDetails[0]?.tenure ?? 0)}
        </p>
      </div>
    </div>
  );
}
